import { Disease, DiseaseQuery } from '@dreryk/medical-dictionaries-api';

import { CqrsQueryPerformResult, performCqrsQuerySearch } from '@dreryk/command-query-react-common';
import { StrongText, Text, TextSeparator, TextSeparatorType } from '@dreryk/react-components';
import { TextPattern } from '@dreryk/watermelon';

export const diseaseItemRenderer = ({ name, icd10Code }: Disease): JSX.Element => {
   return (
      <TextSeparator separator={TextSeparatorType.SPACE}>
         <StrongText testId={'name'}>{name}</StrongText>
         <Text testId={'code'}>{`(${icd10Code})`}</Text>
      </TextSeparator>
   );
};

export const diseasesSearchCreator = (searchText: string | null) => {
   return async (): CqrsQueryPerformResult<Disease[]> =>
      performCqrsQuerySearch<Disease>(() => {
         const query = new DiseaseQuery();
         if (searchText) {
            query.nameOrIcd10Code = TextPattern.anywhereIgnoreCase(searchText);
         }
         return query;
      });
};
